export default __webpack_public_path__ + "static/media/A1.48d3d492.png";